import React, { useEffect, useContext, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import constantData from "../constants/constantData.json";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import loaderIcon from '../assets/images/icons/loader.gif';
import uploadIcon from '../assets/images/icons/upload-cloud.svg';
import pptIcon from '../assets/images/icons/ppt.svg';
import deleteIcon from '../assets/images/icons/trash.svg';
import backButton from '../assets/images/back_button_arrow.svg';
import publishersIcon from '../assets/images/icons/publishers.svg';
import { Radio, Select, Col, Row, Space, Input, Checkbox, Modal, Switch } from 'antd';
import { default as ReactSelect } from 'react-select';
import googleIcon from '../assets/images/icons/google-ads.svg';
import FullLoader from "../assets/images/full-page-loader.gif"
import mediaKitIcon from '../assets/images/icons/download.svg';


const PublisherViewEdit = ({ handlePageViewChange, id, accountStatus, publisherViewName }) => {
    const [formVisible, setFormVisible] = useState(false);
    const [gamCheckboxPrev, setGamCheckBoxPrev] = useState(null);
    const [sellerObjectPrev, setSellerObjectPrev] = useState({ sellerType: "", sellerName: "", sellerDomain: "" })
    const [networkId, setNetworkId] = useState("");


    React.useEffect(() => {

        axios
            .get(configData.SERVER_URL + "user/countryList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCountryOptions(response.data.data);
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "user/dialCodeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDialCodeOptions(response.data.data);
            })
            .catch((error) => { });
    }, [])


    useEffect(() => {

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "ops/getPubDetails?_id=" + id, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setName(response.data.data.p_name)
                    setCompanyName(response.data.data.o_name)
                    setEmail(response.data.data.email)
                    setCompanyWebsite(response.data.data.c_website)
                    setAddress(response.data.data.address.address)
                    setState(response.data.data.address.state)
                    setCity(response.data.data.address.city)
                    setPincode(response.data.data.address.pincode)
                    setCountry(response.data.data.address.country)
                    setSelectedIm(response.data.data.im.label)
                    setIm(response.data.data.im.value)
                    if (response.data.data.phone.code.trim().length !== 0) {
                        setDialCode({ label: response.data.data.phone.code, value: response.data.data.phone.code })
                    }
                    setPhone(response.data.data.phone.p_number)
                    setCompanyLinkedin(response.data.data.o_contact)
                    setSellerType(response.data.data.s_type)
                    setSellerName(response.data.data.s_name)
                    setSellerDomain(response.data.data.s_domain)
                    setIsGamChecked(response.data.data.gam_check)
                    setGamCheckBoxPrev(response.data.data.gam_check)
                    setSellerObjectPrev({ sellerType: response.data.data.s_type, sellerName: response.data.data.s_name, sellerDomain: response.data.data.s_domain })

                    if (response.data.data.gam_check) {
                        setNetworkId(response.data.data.networkId ? response.data.data.networkId : "")
                    }
                    setMediakit(response.data.data.mediaKit)

                    setFormVisible(true)
                })
                .catch((error) => {
                    setFormVisible(true)
                    notifyfailure("Failed to fetch the publisher details.")
                });
        }

    }, [])


    function resetViewPublisher() {
        setGamCheckBoxPrev(null)
        setNetworkId("")
        setFormVisible(false)
        setName("");
        setCompanyName("");
        setEmail("")
        setCompanyWebsite("");
        setIm("");
        setSelectedIm("skype");
        setAddress("");
        setState("");
        setCity("");
        setPincode("");
        // setCountryOptions([]);
        setCountry("");
        // setDialCodeOptions([]);
        setDialCode({ label: "+91", value: "+91" });
        setPhone("");
        setCompanyLinkedin("");
        setSellerType("");
        setSellerName("");
        setSellerNameIsRequiredError(false)
        setSellerDomain("");
        setSellerDomainIsRequiredError(false)
        setSellerDomainUrlError(false)
        setIsGamChecked(false)
        setMediakit([]);
        setButtonValue(false);
        setFormVisible(false)
    }





    ///////////////////////////////////////////onboarding related code starts  /////////////////////////////////////////////////////////////////////////////



    const formatOptionLabel = ({ value, label }) => (
        <div className="d-flex gap-10">
            <span>{label}</span><b>{value}</b>
            {/* <b>{label}</b> */}
        </div>
    );
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    React.useEffect(() => {
        setTimeout(() => {
            const reactInput = document.getElementById('react-select-5-input')
            reactInput?.setAttribute("placeholder", "Search");
        }, 1500);
    })

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    const [name, setName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [email, setEmail] = useState("");
    const [companyWebsite, setCompanyWebsite] = useState("");
    const [im, setIm] = useState("");
    const [selectedIm, setSelectedIm] = useState("skype");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");
    const [countryOptions, setCountryOptions] = useState([]);
    const [country, setCountry] = useState("");
    const [dialCodeOptions, setDialCodeOptions] = useState([]);
    const [dialCode, setDialCode] = useState({ label: "+91", value: "+91" });
    const [phone, setPhone] = useState("");
    const [companyLinkedin, setCompanyLinkedin] = useState("");
    const [sellerType, setSellerType] = useState("");

    const [sellerName, setSellerName] = useState("");
    const [sellerNameIsRequiredError, setSellerNameIsRequiredError] =
        useState(false);
    const [sellerDomain, setSellerDomain] = useState("");
    const [sellerDomainIsRequiredError, setSellerDomainIsRequiredError] =
        useState(false);
    const [sellerDomainUrlError, setSellerDomainUrlError] = useState(false);
    const [isGamChecked, setIsGamChecked] = useState(false);
    const [mediakit, setMediakit] = useState([]);

    const [buttonValue, setButtonValue] = useState(false);

    const fetchAndDownloadFiles = async (ob) => {
        try {

            try {
                const response = await fetch(ob.url);

                if (!response.ok) {
                    throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
                }

                const blob = await response.blob();
                const filename = `${ob.fileName}.${ob?.ext}`;

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;

                // Append the link to the body
                document.body.appendChild(link);

                // Programmatically click the link to trigger the download
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error fetching file:", error);
            }

            notifysuccess("Media kit downloaded successfully");

        } catch (error) {
            notifyfailure("Error while fetching the media kit.");
        }
    };


    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };

    function onChangeSellerType(event) {
        setSellerType(event.target.value);
    }

    function onChangeSellerName(event) {
        setSellerNameIsRequiredError(false);
        setSellerName(event.target.value);
    }

    function onBlurSellerName(event) {
        if (event.target.value.trim().length === 0) {
            setSellerNameIsRequiredError(true);
        }
        setSellerName(event.target.value.trim());
    }

    function onChangeSellerDomain(event) {
        setSellerDomain(event.target.value);

        if (event.target.value.length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            setSellerDomainIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
    }

    function onBlurSellerDomain(event) {
        if (event.target.value.trim().length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
        setSellerDomain(event.target.value.trim());
    }



    const handleSubmit = async (e) => {
        e.preventDefault();


        if (gamCheckboxPrev !== isGamChecked || sellerObjectPrev.sellerType !== sellerType || sellerObjectPrev.sellerName !== sellerName || sellerObjectPrev.sellerDomain !== sellerDomain) {

            if (
                sellerName !== "" &&
                sellerDomain !== ""
            ) {

                if (sellerNameIsRequiredError === false &&
                    sellerDomainIsRequiredError === false &&
                    sellerDomainUrlError === false) {

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        let payload = isGamChecked ? {
                            gam_check: isGamChecked,
                            networkId: networkId,
                            s_type: sellerType,
                            s_name: sellerName,
                            s_domain: sellerDomain
                        } : {
                            gam_check: isGamChecked,
                            s_type: sellerType,
                            s_name: sellerName,
                            s_domain: sellerDomain
                        }

                        setButtonValue(true);
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .put(configData.SERVER_URL + `ops/editPub?pubId=` + id, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                }
                            }
                            )
                            .then((response) => {
                                notifysuccess(response.data.message);
                                handlePageViewChange("table", "yes")
                                resetViewPublisher()
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                                setButtonValue(false);
                            });
                    }
                }
            }
            else {
                if (sellerName === "") {
                    setSellerNameIsRequiredError(true);
                }
                if (sellerDomain === "") {
                    setSellerDomainIsRequiredError(true);
                }
            }
        }


    };

    ///////////////////////////////////////////onboarding related code ends /////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className='container_box--breadcrumb-list'>
                        <li><Link onClick={() => {
                            handlePageViewChange("table", "no")
                            resetViewPublisher()
                        }} ><img src={publishersIcon} alt='USP' /> Publishers</Link></li>
                        <li className='primary'>View</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")
                                resetViewPublisher()
                            }}
                        />
                        <h1 className="heading">
                            {publisherViewName}
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    {formVisible &&
                        <>
                            <div className="container_box--width">


                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Basic details</label>
                                            <p className='sub_text'>General information overview</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Name *</label>
                                                        <Input
                                                            className="form_control basic"
                                                            value={name}

                                                            autocomplete="off"
                                                            disabled
                                                        />
                                                        <span className='error_content'>
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Organisation Name *</label>
                                                        <Input
                                                            className="form_control basic"
                                                            value={companyName}

                                                            autocomplete="off"
                                                            disabled
                                                        />
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Email Address *</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={email}
                                                            disabled
                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Company website *</label>
                                                        <Input
                                                            className="form_control basic"
                                                            value={companyWebsite}

                                                            autocomplete="off"
                                                            disabled
                                                        />
                                                        <span className="error_content">
                                                            <></>

                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>IM *</label>
                                                        <Space.Compact className='form_compact basic disable_compact_d2'>
                                                            <Select
                                                                value={selectedIm}

                                                                options={constantData.IM_OPTIONS}
                                                                className='form_select'
                                                                disabled
                                                            />
                                                            <Input
                                                                className="form_control basic"
                                                                value={im}
                                                                autocomplete="off"
                                                                disabled
                                                            />
                                                        </Space.Compact>
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Address</label>
                                            <p className='sub_text'>Location and mailing address</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Address Line 1</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={address}

                                                            autocomplete="off"
                                                            disabled

                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>City </label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={city}

                                                            autocomplete="off"
                                                            disabled

                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>State</label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={state}

                                                            autocomplete="off"
                                                            disabled

                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label'>Postal/ Zip Code  </label>
                                                        <Input
                                                            className='form_control basic'
                                                            value={pincode}

                                                            autocomplete="off"
                                                            disabled

                                                        />
                                                        <span className="error_content">
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                                        <label className='form_label'>Country  *</label>
                                                        <Select
                                                            showSearch
                                                            // open={true}
                                                            optionFilterProp="label"
                                                            className="form_select basic"
                                                            value={country}

                                                            options={countryOptions}
                                                            disabled
                                                        // onSearch={(value) => {
                                                        //     console.log('search:', value);
                                                        //   }}
                                                        />
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Contact details</label>
                                            <p className='sub_text'>Phone and other conact information</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Phone Number  *</label>
                                                        <div className='input_group input_group_disabled_d2'>
                                                            <ReactSelect
                                                                value={dialCode}

                                                                options={dialCodeOptions}
                                                                isSearchable={true}
                                                                // menuIsOpen={true}
                                                                className="form_select--w-20"
                                                                classNamePrefix="form_select basic"
                                                                formatOptionLabel={formatOptionLabel}
                                                                styles={customStyles}
                                                                placeholder=""
                                                                isDisabled={true}
                                                            />
                                                            <Input
                                                                className="form_control basic"
                                                                value={phone}

                                                                autocomplete="off"
                                                                disabled
                                                            />
                                                        </div>
                                                        {/* } */}
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Linkedin URL </label>
                                                        <Input
                                                            className="form_control basic"
                                                            placeholder='https://'
                                                            value={companyLinkedin}
                                                            disabled
                                                            autocomplete="off"

                                                        />
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Seller details</label>
                                            <p className='sub_text'>Seller's business specifics</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className="form_content_block--group">
                                                        <label className='form_label d_flex'>Seller Type *</label>
                                                        <Radio.Group onChange={onChangeSellerType} value={sellerType}
                                                            disabled={accountStatus !== "Approved"}

                                                            className="form_radio equal_space">
                                                            <Radio className='radio_btn' value="Publisher">Publisher</Radio>
                                                            <Radio className='radio_btn' value="Intermediary">Intermediary</Radio>
                                                            <Radio className='radio_btn' value="Both">Both</Radio>
                                                        </Radio.Group>
                                                        <span className="error_content">
                                                            <></>
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Seller Name *</label>
                                                        <Input
                                                            className={sellerNameIsRequiredError
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            value={sellerName}
                                                            onBlur={onBlurSellerName}
                                                            onChange={onChangeSellerName}
                                                            autocomplete="off"
                                                            disabled={accountStatus !== "Approved"}

                                                        />
                                                        <span className="error_content">
                                                            {sellerNameIsRequiredError && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className='form_label'>Seller Domain *</label>
                                                        <Input
                                                            className={(sellerDomainIsRequiredError || sellerDomainUrlError)
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                            }
                                                            value={sellerDomain}
                                                            onBlur={onBlurSellerDomain}
                                                            onChange={onChangeSellerDomain}
                                                            autocomplete="off"
                                                            disabled={accountStatus !== "Approved"}

                                                        />
                                                        <span className="error_content">
                                                            {sellerDomainIsRequiredError && (
                                                                <> This field is required</>
                                                            )}

                                                            {sellerDomainUrlError && (
                                                                <> Invalid Domain</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                                <Row gutter={16} className='mb-5'>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>GAM Integration</label>
                                            <p className='sub_text'>Google Ad Manager setup</p>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="google_ads_design_d2 form_content_block--group">
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex align-items-center'>
                                                    <img src={googleIcon} className='img-fluid' alt="" />
                                                    <label className='form_label'>Google Ad Manager 360 (MCM)</label>
                                                </div>
                                                <Switch checked={isGamChecked} onChange={() => { setIsGamChecked(!isGamChecked) }}
                                                    disabled={accountStatus !== "Approved" ? true : gamCheckboxPrev}

                                                />
                                            </div>
                                            {isGamChecked &&
                                                <div className="form_content_block--group mt_d2_24">
                                                    <Input className='form_control basic' placeholder="Enter Network ID"
                                                        value={networkId} onChange={(e) => { setNetworkId(e.target.value) }}
                                                        disabled={accountStatus !== "Approved" ? true : gamCheckboxPrev}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Col>
                                </Row>

                                {mediakit?.length > 0 &&
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>Media Kit</label>
                                                <p className='sub_text'>Upload ppt</p>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className="form_content_block--group">


                                                        {mediakit.map((media, index) => (

                                                            <div class="ant_upload_list--item">
                                                                <div class="ant_upload_list--content">
                                                                    <img src={pptIcon} alt="USP" />
                                                                    <div class="ant_upload_list--info">
                                                                        <span class="ant_upload_list--info-name">{media.fileName}</span>
                                                                        {!media.hasOwnProperty('url') ?
                                                                            <span class="ant_upload_list--info-size">{media.size / 1024 > 100 ? `${(media.size / (1024 * 1024)).toFixed(2)} MB` : `${(media.size / (1024)).toFixed(2)} KB`}</span>
                                                                            :
                                                                            <span class="ant_upload_list--info-size"></span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <button className='download_icon download_icon_d2'
                                                                    onClick={() => {
                                                                        fetchAndDownloadFiles(
                                                                            media

                                                                        )

                                                                    }}
                                                                ><img src={mediaKitIcon} alt='USP' /></button>
                                                                {/* <button type="link" class="download_icon download_icon_d2"
                                                                onClick={() => {
                                                                    let tempMediaKit = [...mediakit];
                                                                    tempMediaKit.splice(index, 1);
                                                                    setMediakit(tempMediaKit);
                                                                }}
                                                            >
                                                                <img src={deleteIcon} alt="USP" />
                                                            </button> */}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                }

                            </div>
                            {/* 
                            <div className={!gamCheckboxPrev && (accountStatus === "Approved") ? 'hr_custom mb_20' : 'mb_20'}></div>
                            {!gamCheckboxPrev && (accountStatus === "Approved") &&
                                <>
                                    {buttonValue ?
                                        <div className=" btn_group justify-content-end gap_8 pb_50">
                                            <button className='w_120_d2 btn btn_primary w_fit_content'
                                                disabled
                                            >Save</button>
                                        </div> :
                                        <div className=" btn_group justify-content-end gap_8 pb_50">
                                            <button className='w_120_d2 btn btn_white_outline w_fit_content'
                                                onClick={() => {
                                                    handlePageViewChange("table", "no")
                                                    resetViewPublisher()
                                                }}
                                            >Discard</button>
                                            <button className='w_120_d2 btn btn_primary w_fit_content'
                                                onClick={
                                                    handleSubmit
                                                }
                                                disabled={!formVisible || isGamChecked === gamCheckboxPrev}
                                            >Save</button>
                                        </div>
                                    }
                                </>
                            } */}


                            <div className='mb_20'></div>

                            <>

                                <div className="height_89_d2"></div>
                                {buttonValue ?
                                    <div className=" btn_group justify-content-end gap_8 pb_50 ">
                                        <button className='w_120_d2 btn btn_primary w_fit_content'
                                            disabled
                                        >Save</button>
                                    </div> :
                                    <div className=" btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                                        <button className='w_120_d2 btn btn_white_outline w_fit_content'
                                            onClick={() => {
                                                handlePageViewChange("table", "no")
                                                resetViewPublisher()
                                            }}
                                        >Discard</button>
                                        <button className='w_120_d2 btn btn_primary w_fit_content'
                                            onClick={
                                                handleSubmit
                                            }
                                            disabled={!formVisible || (isGamChecked === gamCheckboxPrev && sellerObjectPrev.sellerType === sellerType && sellerObjectPrev.sellerName === sellerName && sellerObjectPrev.sellerDomain === sellerDomain)}
                                        >Save</button>
                                    </div>
                                }
                            </>


                        </>
                    }
                    {!formVisible &&
                        <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                            <img src={FullLoader} className="mt-5" width={50} height={50} alt="" />
                        </div>
                    }
                </div>

            </div >
        </>

    )

}

export default PublisherViewEdit;